import { render, staticRenderFns } from "./TipoOrgaoForm.vue?vue&type=template&id=61a44c38"
import script from "./TipoOrgaoForm.vue?vue&type=script&lang=js"
export * from "./TipoOrgaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports